<template>
  <v-container class="pa-0 max-width-1200 mx-auto">
    <v-row>
      <v-col cols="2" class="mt-1 ml-1">
        <div class="d-flex align-center">
          <v-card
            flat color="transparent" dark
            :ripple="false"
            class="d-flex"
            style="min-width:210px;"
            @click="loadPage('Home')">
            <span><img
              alt="Rubin Infomatika logó"
              class="shrink mr-2"
              contain
              :src="logoType"
              transition="scale-transition"
              height="24" width="24"></span>
            <span class="brand-title pr-2" style="margin-top:2px;" :style="text == 'dark' ? 'color: #000000;' : 'color: #ffffff;'">{{ $t('rubin.rubin') }}</span>
            <span class="brand-subtitle"   style="margin-top:8px;" :style="text == 'dark' ? 'color: #000000;' : 'color: #ffffff;'">{{ $t('rubin.informatic') }}</span>
          </v-card>
        </div>
      </v-col>
      <v-spacer>
      </v-spacer>

      <!-- top menu -->
      <v-col v-if="!mini" cols="8" class="pt-2 text-end">
        <!-- <v-btn
          class="mr-2"
          text dark
          @click="loadPage('Home')">
          {{ $t('common.home') }}
        </v-btn> -->
        <v-btn
          text :dark="text == 'dark' ? false : true"
          @click="loadPage('RubinAbout')">
          {{ $t('common.rubinAbout') }}
        </v-btn>
        <v-btn
          text :dark="text == 'dark' ? false : true"
          @click="loadPage('ItSolutions')">
          {{ $t('service.itSolutions.title') }}
        </v-btn>
        <v-btn
          text :dark="text == 'dark' ? false : true"
          @click="loadPage('EnergyManagement')">
          {{ $t('service.ernergyManagement.title') }}
        </v-btn>
        <v-btn
          text :dark="text == 'dark' ? false : true"
          @click="loadPage('Hardware')">
          {{ $t('service.hardware.title') }}
        </v-btn>
      </v-col>
      <v-col v-if="mini" class="pt-2 pr-0 text-end">
        <v-btn
          id="btn_menu_bar"
          title="menu"
          name="menu"
          text :dark="text == 'dark' ? false : true"
          class="animate__animated"
          @click="openMenu()">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </v-col>
      <!-- language select -->
      <div class="langSelectMenuBtnDiv pt-2" :class="mini ? 'mr-2' : ''">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id=""
              title="language"
              name="language"
              light icon
              v-bind="attrs"
              v-on="on">
              <!-- <v-img :src="$store.getters.selectedLanguage.flag" max-width="16"></v-img> -->
              <v-img :src="selectedLanguageDetails.flag" max-width="16"></v-img>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item
              v-for="(item, index) in language.items"
              :key="index"
              @click="changeLanguage(item)">
              <v-list-item-title><v-img :src="item.flag" width="16"></v-img></v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="$route.path.endsWith('/energia-monitor')"
              @click="setLangDe(true)">
              <!-- open german flyer on dialof -->
              <v-list-item-title><v-img src="@/assets/flag-de.png" width="16"></v-img></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-row>

    <v-dialog
      v-model="fullscreenMenu"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card color="primary">
        <v-toolbar flat color="primary">
          <v-spacer></v-spacer>
          <v-btn
            icon dark
            @click="closeMenu()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-row class="justify-center align-center">
          <v-btn
            class="mr-2"
            text dark block
            @click="loadPage('RubinAbout')">
            {{ $t('common.rubinAbout') }}
          </v-btn>
          <v-btn
            class="mr-2"
            text dark block
            @click="loadPage('ItSolutions')">
            {{ $t('service.itSolutions.title') }}
          </v-btn>
          <v-btn
            class="mr-2"
            text dark block
            @click="loadPage('EnergyManagement')">
            {{ $t('service.ernergyManagement.title') }}
          </v-btn>
          <v-btn
            class="mr-2"
            text dark block
            @click="loadPage('Hardware')">
            {{ $t('service.hardware.title') }}
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'AppBar',
    extends: DataComponentBase,

    props: {
      component: {
        type: String,
        default: "",
      },
      logo: {
        type: String,
        default: "light",
      },
      text: {
        type: String,
        default: "light",
      },
    },

    data() {
      return {
        fullscreenMenu: false,
      }
    },

    computed: {
      mini() {
        if (this.computedWidth < 800) {
          return true
        } else {
          return false
        }
      },

      logoType() {
        switch (this.logo) {
          case 'grad':
            return require('@/assets/logo-grad-ruby.svg')
            break;
          case 'light':
            return require('@/assets/logo-flat-light.svg')
            // return require('../../assets/logo-flat-light.svg')
            break;
          case 'dark':
            return require('@/assets/logo-flat-dark.svg')
            break;
          default:
            break;
        }
      },

    },

    methods: {
      openMenu() {
        this.fullscreenMenu = true;
      },
      closeMenu() {
        this.fullscreenMenu = false;
      },
    },

  }

</script>
